import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { AppVersionForm } from '@/components/forms/AppVersionForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateAppVersionPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  return (
    <AdminLayout>
      <Box p={4}>
        <Card>
          <CardHeader>
            <Heading size="md">Create App Version</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>Publish a new mobile app version</Text>
          </CardHeader>
          <CardBody>
            <AppVersionForm onSuccess={() => navigate('/system-settings/app-versions')} onCancel={() => navigate('/system-settings/app-versions')} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
